<script>
import DatePickerField from '@phoenix/mixins/components/form/fields/DatePickerField';
import { useField } from '@phoenix/composables/field';

export default {
  mixins: [DatePickerField],

  props: {
    flatpickr: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    return useField(props);
  },

  computed: {
    customFieldClasses() {
      return ['field--text', this.fieldClasses];
    },
  },

  async mounted() {
    const lang = document.documentElement.lang;
    const isArLanguage = lang.startsWith('ar');

    const params = {
      altInput: true,
      altFormat: 'j F Y',
      minDate: this.field.minDate,
      maxDate: this.field.maxDate,
      disable: [this.isDisabledDate],
    };

    if (isArLanguage) {
      params.locale = await import('flatpickr/dist/l10n/ar.js').then((module) => module.Arabic);
    }

    // If we want to use flatpickr instead of the native date picker from the browser
    Toolkit.datepickerField(this.$refs[this.field.id], params, this.flatpickr === true || isArLanguage);
  },
};
</script>

<template>
  <input
    :id="fieldUniqueId"
    :ref="field.id"
    v-model="value"
    type="date"
    :name="field.name"
    :class="customFieldClasses"
    :aria-describedby="ariaDescribedby"
    :aria-label="field.ariaLabel"
    :placeholder="field.placeholder"
    :disabled="field.disabled"
    :min="field.minDate"
    :max="field.maxDate"
  />
</template>
